'use client'

import '@/(front-desk)/utils/api.js'
import { useEffect } from 'react'
import store, { handleGlobal } from '@/(front-desk)/store'
import { Noto_Sans_TC, Sora, Zen_Dots } from 'next/font/google'
import { usePathname, useParams } from 'next/navigation'
import { Provider } from 'react-redux'
import { GoogleAnalytics } from 'nextjs-google-analytics'
import { ToastContainer } from 'react-toastify'
import classNames from 'classnames'
import lscache from 'lscache'
import smoothscroll from 'smoothscroll-polyfill'
import 'react-toastify/dist/ReactToastify.css'
import '@/(front-desk)/styles/globals.scss'


// const inter = Inter({
//     weight: ['300', '400', '500', '600', '700', '800'],
//     subsets: ['latin'],
//     variable: '--font-inter'
// })
const zenDots = Zen_Dots({
    weight: ['400'],
    subsets: ['latin'],
    variable: '--font-zen-dots'
})
const notoSans = Noto_Sans_TC({
    weight: ['300', '400', '500', '600', '700', '800'],
    subsets: ['latin'],
    variable: '--font-noto-sans'
})
const sora = Sora({
    weight: ['300', '400', '500', '600', '700', '800'],
    subsets: ['latin'],
    variable: '--font-sora'
})

export const loginPages = [
    '/user/login', '/user/sign-up', '/user/password-forget', '/user/password-reset', '/user/email-verify'
]

export default function FrontPageLayout({ children }) {
    const dispatch = store.dispatch
    const pathname = usePathname()
    const params = useParams()
    const locale = params.locale === 'en' ? 'en' : 'zh_hant'
    const pageContentClass = classNames('page-content',
        notoSans.variable, sora.variable, zenDots.variable,{
        'user': pathname.indexOf('user') !== -1 && loginPages.indexOf(pathname) === -1,
        'full': loginPages.indexOf(pathname) !== -1
    })

    useEffect(() => {
        smoothscroll.polyfill()
        handleCurrentYear()
        handleLanguage()
        window.addEventListener('click', handleWindowClick, null)

        return () => {
            window.removeEventListener('click', handleWindowClick, null)
        }
    }, [locale])

    function handleCurrentYear() {
        store.dispatch(handleGlobal.actions.setCurrentExhibitYear(2026))
        store.dispatch(handleGlobal.actions.setCurrentCompeteYear(2026))
    }
    function handleLanguage() {
        // Use locale from URL instead of navigator language
        store.dispatch(handleGlobal.actions.setLanguage(locale))
        lscache.set('language', locale)
    }
    function handleWindowClick() {
        dispatch(handleGlobal.actions.setUserInteraction(true))
        window.removeEventListener('click', handleWindowClick, null)
    }

    return (
        <>
        <GoogleAnalytics />
        <Provider store={store}>
            <link rel="stylesheet" href="https://use.typekit.net/fde7tmf.css" />
            <div className={pageContentClass}>
                <a className="go-main" href="#main">跳到主要內容</a>
                <ToastContainer />
                {children}
            </div>
        </Provider>
        </>
    )
}
